(function () {
	angular
		.module('trackeye')
		.factory('FleetService', FleetService);

	FleetService.$inject = ["AppFactory"];

	function FleetService(App) {
		var exports = {},
			fleets = [
				{name: null, locale: "STR_NO_MARKER", image: null},

				{name: "trailer-box", locale: "STR_TRAILER_TRAILER_BOX", image: "trailer-box.svg", scale: .35},
				{
					name: "trailer-curtainside",
					locale: "STR_TRAILER_TRAILER_CURTAINSIDE",
					image: "trailer-curtainside.svg",
					scale: .35
				},
				{
					name: "trailer-double",
					locale: "STR_TRAILER_TRAILER_DOUBLE",
					image: "trailer-double-deck.svg",
					scale: .35
				},
				{
					name: "trailer-flatbed",
					locale: "STR_TRAILER_TRAILER_FLATBED",
					image: "trailer-flatbed.svg",
					scale: .35
				},
				{
					name: "trailer-refridgerated",
					locale: "STR_TRAILER_TRAILER_REFRIDGERATED",
					image: "trailer-refridgerated.svg",
					scale: .35
				},
				{
					name: "stackview-green",
					locale: "STR_STACKVIEW_GREEN",
					image: "stackview_green.svg",
					scale: .35
				},
				{
					name: "stackview-yellow",
					locale: "STR_STACKVIEW_YELLOW",
					image: "stackview_yellow.svg",
					scale: .35
				},
				{name: "trailer-tanker", locale: "STR_TRAILER_TRAILER_TANKER", image: "trailer-tanker.svg", scale: .35},

				{name: "add", locale: "STR_PLUS", image: "add.png"},
				{name: "anchor", locale: "STR_ANCHOR", image: "anchor.png"},
				{name: "flower-orange", locale: "STR_ASTERISK_ORANGE", image: "flower-orange.png"},
				{name: "flower-red", locale: "STR_ASTERISK_RED", image: "flower-red.png"},
				{name: "flower-yellow", locale: "STR_ASTERISK_YELLOW", image: "flower-yellow.png"},
				{name: "star-blue-2", locale: "STR_AWARD_STAR_PLUS", image: "star-blue-2.png"},
				{name: "star-green", locale: "STR_AWARD_STAR_BRONZE_GREEN", image: "star-green.png"},
				{name: "star-blue-1", locale: "STR_AWARD_STAR_BRONZE_BLUE", image: "star-blue-1.png"},
				{name: "star-red-2", locale: "STR_AWARD_STAR_BRONZE_RED", image: "star-red-2.png"},
				{name: "star-red-1", locale: "STR_AWARD_STAR_GOLD_RED", image: "star-red-1.png"},

				{name: "blue-trailer-3", locale: "STR_TRAILER_BLUE", image: "blue-trailer-3.png"},
				{name: "blue-trailer-2", locale: "STR_TRAILER_SMALL_BLUE", image: "blue-trailer-2.png"},
				{name: "blue-trailer-1", locale: "STR_DRAWBAR_TRAILER_BLUE", image: "blue-trailer-1.png"},
				{name: "blue-car", locale: "STR_CAR_BLUE", image: "blue-car.png"},
				{name: "blue-truck-2", locale: "STR_TRUCK_BLUE", image: "blue-truck-2.png"},
				{name: "blue-truck-1", locale: "STR_TRUCK_FLATBED_BLUE", image: "blue-truck-1.png"},
				{name: "blue-truck-3", locale: "STR_TRUCK_PULLER_BLUE", image: "blue-truck-3.png"},

				{name: "green-trailer-3", locale: "STR_TRAILER_GREEN", image: "green-trailer-3.png"},
				{name: "green-trailer-2", locale: "STR_TRAILER_SMALL_GREEN", image: "green-trailer-2.png"},
				{name: "green-trailer-1", locale: "STR_DRAWBAR_TRAILER_GREEN", image: "green-trailer-1.png"},
				{name: "green-car", locale: "STR_CAR_GREEN", image: "green-car.png"},
				{name: "green-truck-2", locale: "STR_TRUCK_GREEN", image: "green-truck-2.png"},
				{name: "green-truck-1", locale: "STR_TRUCK_FLATBED_GREEN", image: "green-truck-1.png"},

				{name: "red-trailer-3", locale: "STR_TRAILER_RED", image: "red-trailer-3.png"},
				{name: "red-trailer-2", locale: "STR_TRAILER_SMALL_RED", image: "red-trailer-2.png"},
				{name: "red-trailer-1", locale: "STR_DRAWBAR_TRAILER_RED", image: "red-trailer-1.png"},
				{name: "red-truck-2", locale: "STR_TRUCK_RED", image: "red-truck-2.png"},
				{name: "red-truck-1", locale: "STR_TRUCK_FLATBED_RED", image: "red-truck-1.png"},
				{name: "red-boat", locale: "STR_BOAT_RED", image: "red-boat.png"},

				{name: "yellow-truck", locale: "STR_TRUCK_TOW_YELLOW", image: "yellow-truck.png"}
			];

		exports.getFleetByName = function (name) {
			for (var idx in fleets) {
				if (fleets[idx].name == name)
					return fleets[idx];
			}
			return null;
		};

		exports.getFleets = function () {
			return fleets;
		};

		return exports;
	}
})();